import React from 'react';
import { useSelector } from 'react-redux';
import {
  getHandlingFeeDescription,
  getPaymentMethod,
  getRefundCostDescription,
  getRevenueDescription,
  getShippingCostDescription,
} from './utils';

import styles from './ActivationServices.module.scss';

export default function ActivationServices() {
  const { supplierRetailer } = useSelector((state) => state.activation);

  const isServiceActive = (value) => {
    return (
      <span className={value ? styles.active : styles.notActive}>
        {value ? ' SERVICE IS ACTIVE' : ' SERVICE IS NOT ACTIVE'}
      </span>
    );
  };

  const {
    approved_for_ecommerce,
    approved_for_replenishment,
    ecommerce_billing_method,
    minimum_products_for_replenishment_order,
    minimum_order_value_for_replenishment_order,
    replenish_billing_method,
    replenishment_order_shipping_cost,
    replenishment_shipper_account_type,
    replenishment_shipper_account,
  } = supplierRetailer;

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.card}>
          <div className={styles.body}>
            <h4>DROP SHIP TERMS - {isServiceActive(approved_for_ecommerce)}</h4>

            <ul>
              <li>{getRevenueDescription(supplierRetailer.ecommerce_unit_price_formula)}</li>
              <li>{getHandlingFeeDescription(supplierRetailer.handling_fee_formula)}</li>
              <li>{getRefundCostDescription(supplierRetailer.refund_cost_formula)}</li>
              <li>{getPaymentMethod(ecommerce_billing_method)}</li>
            </ul>

            {!approved_for_ecommerce ? (
              <div>
                <span>TO ACTIVATE:</span>
                <p>1. Add eCom integration.</p>
                <p>2. Add credit card.</p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className={styles.card}>
        <div className={styles.body}>
          <h4>REORDER TERMS - {isServiceActive(approved_for_replenishment)}</h4>

          {getShippingCostDescription(
            replenishment_shipper_account_type,
            replenishment_shipper_account,
            replenishment_order_shipping_cost,
          )}

          <ul>
            {minimum_products_for_replenishment_order ? (
              <li> Minimum units/cases per order: {minimum_products_for_replenishment_order}</li>
            ) : null}

            {minimum_order_value_for_replenishment_order ? (
              <li> Minimum value per order: {minimum_order_value_for_replenishment_order}</li>
            ) : null}

            <li>{getPaymentMethod(replenish_billing_method)}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
